import type { AuthSessionState } from "@cmmd-forge/contracts";

import { BootstrapHttpError } from "./bootstrapError";
import { readJsonResponse } from "./jsonResponse";
import {
  resolvePrimaryAccountIdentityFromSession,
  type PrimaryAccountIdentity,
} from "./authIdentityResolver";

let originAccountIdentityPromise: Promise<PrimaryAccountIdentity> | null = null;

export function fetchCurrentOriginAccountIdentity(): Promise<PrimaryAccountIdentity> {
  if (originAccountIdentityPromise) return originAccountIdentityPromise;
  const url = new URL("/api/auth/session", window.location.origin).toString();
  const next = fetch(url, { credentials: "include" })
    .then(async (response) => {
      if (!response.ok) {
        throw new BootstrapHttpError({
          message: `Failed to load current app auth session state (${response.status}).`,
          status: response.status,
        });
      }
      return readJsonResponse<AuthSessionState>(response, url);
    })
    .then(resolvePrimaryAccountIdentityFromSession)
    .finally(() => {
      if (originAccountIdentityPromise === next) {
        originAccountIdentityPromise = null;
      }
    });
  originAccountIdentityPromise = next;
  return next;
}

export function __resetOriginSessionForTests(): void {
  originAccountIdentityPromise = null;
}
